import axios, {AxiosResponse} from 'axios';
import {
    AdminRolePrivilegeRetrieveResponse, AdminRolesRetrieveResponse, AdminSettingsRetrieveResponse, AdminUserRetrieveResponse,
    AdminUsersRetrieveResponse, AdminRolesAuditTrailsResponse, AdminSettingsAuditTrailResponse, AdminUserAuditTrailsResponse,
    AdminSettingsNumberSettingAuditTrailsResponse
} from '@/model/CommonModel';

export default class AdminApi {
    public static retrieveAdminUsers(sponsorKey: number, params: any = {}): Promise<AdminUsersRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/users`, {params})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveAdminUser(sponsorKey: string, userKey: string): Promise<AdminUserRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/users/${userKey}`)
            .then((res: AxiosResponse) => res.data);
    }

    public static getAdminUserAuditTrails(sponsorKey: string, userKey: string, params: any = {}): Promise<AdminUserAuditTrailsResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/users/${userKey}/audit-trail`, {params})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static saveAdminUser(sponsorKey: string, userKey: string, params: any): Promise<AdminUserRetrieveResponse> {
        return axios
            .put(`/1.0/sponsors/${sponsorKey}/users/${userKey}`, params)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveAdminRoles(sponsorKey: string): Promise<AdminRolesRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/roles`)
            .then((res: AxiosResponse) => res.data);
    }

    public static getAdminRolesAuditTrails(sponsorKey: string, roleId: string): Promise<AdminRolesAuditTrailsResponse> {

        return axios
            .get(`/1.0/sponsors/${sponsorKey}/roles/${roleId}/audit-trail`)
            .then((res: AxiosResponse) => res.data);
    }

    public static saveAdminRole(sponsorKey: string, params: any): Promise<any> {
        return axios
            .put(`/1.0/sponsors/${sponsorKey}/roles`, params)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveAdminRolePrivileges(sponsorKey: string): Promise<AdminRolePrivilegeRetrieveResponse> {
        return axios
            .get(`/1.1/sponsors/${sponsorKey}/privileges`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static saveAdminRolePrivilege(sponsorKey: string, params: any): Promise<any> {
        return axios
            .put(`/1.1/sponsors/${sponsorKey}/privileges`, params)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveAdminSettings(sponsorKey: string): Promise<AdminSettingsRetrieveResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/settings`)
            .then((res: AxiosResponse) => res.data);
    }

    public static getAdminSettingsAuditTrails(sponsorKey: string, params: any = {}): Promise<AdminSettingsAuditTrailResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/audit-trail`, {params})
            .then((res: AxiosResponse) => res.data);
    }

    public static getAdminSettingsAppendixAuditTrails(sponsorKey: string, appendixCode: string): Promise<AdminSettingsAuditTrailResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/appendix-audit-trail/${appendixCode}`)
            .then((res: AxiosResponse) => res.data);
    }

    public static getAdminSettingsNumberSettingAuditTrail(sponsorKey: string): Promise<AdminSettingsNumberSettingAuditTrailsResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/settings/audit-trail`)
            .then((res: AxiosResponse) => res.data);
    }

    public static saveAdminSettings(sponsorKey: string, param: any): Promise<AdminSettingsRetrieveResponse> {
        return axios
            .post(`/1.1/sponsors/${sponsorKey}/settings`, param)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static getAdminSettingsWorkflowAuditTrails(sponsorKey: string, workflowKey: string, params: any = {})
        : Promise<AdminSettingsAuditTrailResponse> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/workflow/${workflowKey}/audit-trail`, {params})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveWorkflowItems(sponsorKey: number | string): Promise<any> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/workflow/options`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveNotation(sponsorKey: number | string): Promise<any> {
        return axios
            .get(`/1.0/sponsors/${sponsorKey}/notation`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static retrieveIdf(sponsorKey: number | string): Promise<any> {
        return axios
            .get(`1.0/sponsors/${sponsorKey}/idf`)
            .then((res: AxiosResponse) => res.data);
    }

    public static retrieveCiomsOrientation(sponsorKey: number | string): Promise<any> {
        return axios
          .get(`1.0/sponsors/${sponsorKey}/cioms-orientation`)
          .then((res: AxiosResponse) => res.data);
    }

    public static retrieveCiomsDataOrdering(sponsorKey: number | string): Promise<any> {
        return axios
            .get(`1.0/sponsors/${sponsorKey}/cioms-data-ordering`)
            .then((res: AxiosResponse) => res.data);
    }
}
